import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppService } from '../services/app.service';
import { LoggingService } from '../services/logging.service';
import { wrapAllMethodsWithLogging } from '../core/decorators/log-all-errors.decorator';

@Injectable()

export class tempDynamicStoreconfig {
  public isRunningSaveData = new BehaviorSubject(false);
  public serverData;
  public serverDataKeys;
  public fileMetaData;
  public uiBinding;
  public serverUiBindings;
  public serverDataValidation;
  public taskImagesList;
  public taskAudioList;
  public localFiles;
  public noCatImageReason: any = [];
  public getHelpJsonData: any = [];
  public getHelpGuideFile: any = [];
  public serverDataQues: any;
  public lastSlideIndex: any = 0;
  public serverUrl: any;
  public taskChecklist;
  public tasklevelChecklistValue: any;
  public originalFileName;
  public zoneNames;
  public zoneChecklistvalue;
  // New Variables
  // New Section -------------------------------------------------------------
  public taskTemplatesDetails: any = [];
  indexOfSelectZone: any;
  lastSelection: any;
  public FileName;
  public tempCustomJson: any;
  public externalApiTemplateData: any;
  public highlightcontrols: boolean = false;
  public checklistChanges: boolean = false;
  public isHelpJsonLoad: boolean = false;
  tempTemplateData: any;
  taskVerificationDetails: any;
  componentName: string = 'tempDynamicStoreCOnfig';

  constructor(
    public loggingService: LoggingService
  ) {
    wrapAllMethodsWithLogging(this, this.componentName);
  }
  getControlDetailsByControlId(templateId, UniqueId) {
    return this.taskTemplatesDetails.filter(item => item.templateId == templateId)[0].templateJson.filter(item2 => item2.controlName == UniqueId)[0];
  }

  childToParentTree(templateId, selectedControl) {
    let parentObj = selectedControl;
    let childToParent = [];
    let templateIndex = this.serverData.findIndex(item => item.templateId == templateId)
    childToParent.push(this.serverData[templateIndex])
    let ChildToParentStructer;
    let parent = {};
    while (parentObj.parent != '') {
      ChildToParentStructer = this.serverData[templateIndex].templateJson.filter(item => item.controlName == parentObj.parent);
      if (ChildToParentStructer[0].parent != '') {
        parentObj = ChildToParentStructer[0];
        parent = ChildToParentStructer[0];
        ChildToParentStructer = this.serverData[templateIndex].templateJson.filter(item => item.controlName == ChildToParentStructer[0].parent);
        ChildToParentStructer[0].children = this.get_Zone_tree_List(this.serverData[templateIndex].templateJson, ChildToParentStructer[0].controlName)
        childToParent.push(ChildToParentStructer[0])
      } else if (Object.keys(parent).length != 0) {
        childToParent.push(parent)
        parentObj = ChildToParentStructer[0];
      } else {
        ChildToParentStructer[0].children = this.get_Zone_tree_List(this.serverData[templateIndex].templateJson, ChildToParentStructer[0].controlName)
        parentObj = ChildToParentStructer[0];
        childToParent.push(parentObj)
        parentObj = ChildToParentStructer[0];
      }
    }
    childToParent.push(selectedControl);
    return childToParent;
    // this.serverData[0].templateJson.filter(item=>item.)

  }
  getTreeByZoneIndex(index) {
    return this.get_Zone_tree_List(this.serverData[index].templateJson)
  }
  metaDataDetailMapped(templateId, i = null) {
    var catValues = [];
    let templateIndex = this.serverData.findIndex(item => item.templateId == templateId);
    this.serverData[templateIndex].templateJson.forEach((cat, i) => {
      if (this.fileMetaData && this.fileMetaData.length > 0) {
        this.fileMetaData.forEach((elm, j) => {
          if (cat.controlName === elm.controlId && elm.status == 'Active' && cat.isVisible) {
            catValues.push(elm)
          } else if (cat.controlName === elm.controlId && elm.status == 'inActive') {
            if (cat['value'] && cat['value'].length > 0) {
              cat.ui.class = ''
              delete cat['value']
            }
          }
        });
      }
    });
    return catValues
  }

  // metaDataDetailMapped(templateId, i = null) {
  //   var catValues = [];
  //   let templateIndex = this.serverData.findIndex(item => item.templateId == templateId);
  //   this.serverData[templateIndex].templateJson.forEach((cat, i) => {
  //     if ((cat.controlType == "photos" || cat.controlType == "videos" || cat.controlType == "files" || cat.controlType == "satellite") && cat.hasOwnProperty("value")) {
  //       if (cat.value && cat.value.length > 0) {
  //         const matchedMeta = this.fileMetaData.find(elm => cat.controlName === elm.controlId);
  //         if (matchedMeta) {
  //           cat.value.forEach(item => {
  //             if (cat.aiTypeId) item.aiEnable = 'true';
  //             catValues.push(item);
  //           });
  //         }
  //       }
  //     }
  //   });
  //   return catValues
  // }


  getRecomendendCOntrolList(templateId) {
    var recomendedOrMendetoryControlList = [];
    let templateIndex = this.serverData.findIndex(item => item.templateId == templateId);
    recomendedOrMendetoryControlList = this.serverData[templateIndex].templateJson.filter(ele => (ele.controlType == "photos" || ele.controlType == "videos") && !ele.hasOwnProperty('value') && ele.mandatory != 0 && ele.isVisible)
    return recomendedOrMendetoryControlList;
  }

  // totalmedia(templateId) {
  //   // return customjsonFormData.filter(item=>item.mandatory == true)
  //   let templateIndex = this.serverData.findIndex(item => item.templateId == templateId);
  //   return this.serverData[templateIndex].templateJson.filter(ele => (ele.controlType == "photos" || ele.controlType == "videos"))
  // }


  // convertTreeToList(root) {
  //   var stack = [], array = [];
  //   stack.push(root);
  //   while (stack.length !== 0) {
  //     var node = stack.pop();
  //     if (node.children === null || node.children.length == 0 && node.valueControl) {
  //       array.push(node);
  //     } else {
  //       for (var i = node.children.length - 1; i >= 0; i--) {
  //         stack.push(node.children[i]);
  //       }
  //     }
  //   }
  //   return array;
  // }
  // calculatePercent(arr) {
  //   let valueHoldedObj = arr.filter(item => item.hasOwnProperty('value') && item.value && item.value != "");
  //   return Math.floor((valueHoldedObj.length / arr.length) * 100) > 0 ? Math.floor((valueHoldedObj.length / arr.length) * 100) : 0;
  // }

  // pendingmedia(templateId) {
  //   // return customjsonFormData.filter(item=>item.mandatory == true)
  //   let templateIndex = this.serverData.findIndex(item => item.templateId == templateId);
  //   return this.serverData[templateIndex].templateJson.filter(ele => (ele.controlType == "photos" || ele.controlType == "videos") && ele.value == undefined)
  // }

  jsonValueMapped(templateId, i = null) {
    console.log("templateId", templateId)
    let templateIndex = this.serverData.findIndex(item => item.templateId == templateId);
    const templateData = this.serverData[templateIndex];
    console.log("templateData", templateData);
    templateData.templateJson.forEach((cat, i) => {

      if (this.fileMetaData && this.fileMetaData.length > 0) {

        const fileList = this.fileMetaData.filter(
          elm => cat.controlName === elm.controlId
        );

        if (fileList.length > 0) {
          cat['value'] = fileList;   // assign when matched
        } else {
          delete cat['value'];       // remove when no match
        }
      } else {
        delete cat['value'];         // remove if no metadata
      }
    });

    if (templateData.templateQues?.length > 0 && this.zoneChecklistvalue?.length > 0) {
      console.log("this.zoneChecklistvalue", this.zoneChecklistvalue)
      this.zoneChecklistvalue.forEach(item => {
        const matchingQues = templateData.templateQues.find(ele => ele.controlName === item.controlName && item.templateId === templateId);
        if (matchingQues) {
          if (item.controlType === 'table') {
            matchingQues.tableData.value = item.controlvalue;
          } else {
            matchingQues.controlvalue = item.controlvalue;
          }
        }
      });
    }

    if (this.taskChecklist && this.taskChecklist.length > 0 && this.tasklevelChecklistValue != null && this.tasklevelChecklistValue.length > 0) {
      this.tasklevelChecklistValue.forEach(item => {
        if (item.controlType == 'table') {
          this.taskChecklist.filter(ele => ele.controlName == item.controlName)[0].tableData.value = item.controlvalue
        } else {
          this.taskChecklist.filter(ele => ele.controlName == item.controlName)[0].controlvalue = item.controlvalue
        }
      })
    }
    return templateData
  }
  GetAllZones() {
    var zoneNameList = [];
    this.serverData.forEach(element => {
      var obj = { zoneName: element.templateName, templateId: element.templateId }
      zoneNameList.push(obj);
    });
    return zoneNameList;
  }

  // addCircleClass(customjsonFormData) {
  //   customjsonFormData.forEach(e => {
  //     if (e.children.length > 0) {
  //       let moreChildren = e.children.filter(itm => (itm.controlType == 'title'))

  //       let checkvalue = e.children.filter(item => (item.value != undefined && item.value != ""));
  //       checkvalue.forEach(itm => {
  //         if (itm.controlType == "photos" || itm.controlType == "videos") {
  //           itm.ui.class = ('btn-circlecompleted');
  //         }
  //       })

  //       if (checkvalue.length == 0) {
  //         e.children.forEach(itm => {
  //           itm.ui.class = ''
  //         })
  //       }

  //       if (checkvalue.length - e.children.length == 0) {
  //         e.ui.class = ('btn-circlecompleted');
  //       } else if (checkvalue.length >= 1) {
  //         let tempCalc = 90 + (360 * ((checkvalue.length / e.children.length)));
  //         e.ui.class = ('btn-circlepartialcompleted' + tempCalc);
  //       } else if (e.controlType == 'title' && e.mandatory == 1) {
  //         e.ui.class = 'mandetory';
  //       } else {
  //         e.ui.class = '';
  //       }
  //     } else {
  //       if ((e.controlType == 'photos' || e.controlType == 'videos') && e.value != null && e.value != undefined) {
  //         e.ui.class = ('btn-circlecompleted');
  //       } else if ((e.controlType == 'photos' || e.controlType == 'videos') && e.mandatory == 1) {
  //         e.ui.class = 'mandetory';
  //       } else {
  //         e.ui.class = '';
  //       }
  //     }
  //   });
  // }
  // ------------------------------------------------------------------------- 
  // getZoneWiseImageList(zone, i = null) {
  //   var zoneIndex = this.getSelectedZoneIndex(zone);
  //   var FileList = [];
  //   this.serverData[i].templateJson.forEach(cat => {
  //     if ((cat.controlType == "photos" || cat.controlType == "videos") && cat.hasOwnProperty("value")) {
  //       if (this.isValidJson(cat.value) && cat.value.length > 0) {
  //         var catValues = JSON.parse(cat.value);
  //         catValues.forEach(file => {
  //           const mapFileValue = file;
  //           mapFileValue.categoryName = this.getParentControlTitle(zoneIndex, cat.parent);
  //           mapFileValue.controlName = cat.controlName;
  //           mapFileValue.MetaData = JSON.parse(mapFileValue.MetaData);
  //           mapFileValue.descriptionName = cat.ui.description
  //           if (this.taskImagesList && this.taskImagesList.length > 0) {
  //             var liveImgDetails = this.taskImagesList.filter(img => img.serverFileName == mapFileValue.ServerFileName);
  //             mapFileValue.LiveUrl = liveImgDetails.length > 0 ? liveImgDetails[0].filePath : "";
  //           }
  //           FileList.push(mapFileValue);
  //         });
  //       }
  //     }
  //   });
  //   return FileList;
  // }
  get_Zone_tree_List = (items, controlName = "", link = 'parent') => items
    .filter(item => item[link] == controlName && item.valueControl)
    .map(item => ({ ...item, children: this.get_Zone_tree_List(items, item.controlName) }));
  get_Camera_Control_tree_List = (items, controlName = "", link = 'parent') => items
    .filter(item => item[link] == controlName && item.valueControl && (item.controlType == "photos" || item.controlType == "videos" || item.controlType == "title"))
    .map(item => ({ ...item, children: this.get_Camera_Control_tree_List(items, item.controlName) }));
  testmethod(zoneTree, temparr = []) {
    zoneTree.forEach(el => {
      if (el.children.length > 0) {
        temparr.push(el);
        this.testmethod(el.children, temparr);
      }
      else {
        temparr.push(el);
      }
    });
    return temparr;
  }
  checkTitle(element) {
    var tiertitle = '';
    if (element && element.hasOwnProperty('props')) {
      tiertitle = element.props['text'] ? this.trimPrefixRequiredItem(element.props['text']) : element.controlName
    } else if (element && element.ui.hasOwnProperty('description')) {
      tiertitle = element.ui.description ? this.trimPrefixRequiredItem(element.ui.description) : element.controlName
    }
    return tiertitle;
  }
  trimPrefixRequiredItem(desc) {
    return desc.split('*] ').length > 1 ? desc.split('*] ')[1] : desc.split('*] ')[0];
  }
  // getParentChildDetails(parent, controlName, name, lebel) {
  //   let displayarr = [{ tierValue: controlName, tierDescription: "", tierchildren: [], checkAllChildValue: false, edditedControlName: lebel }];
  //   const zoneIndex = this.indexOfSelectZone;
  //   var fullTree = [];
  //   fullTree = [...new Set([...fullTree, ...this.get_Camera_Control_tree_List(this.serverData[this.indexOfSelectZone].templateJson)])];
  //   var zoneTree = this.get_Camera_Control_tree_List(this.serverData[this.indexOfSelectZone].templateJson);
  //   var uniqueset = this.testmethod(zoneTree, []);
  //   this.serverData[this.indexOfSelectZone].templateJson.forEach(ele => {
  //     if (ele.controlName === parent && ele.valueControl == true) {
  //       var childrens = [];
  //       const childIndex = uniqueset.findIndex(item => item.controlName === ele.controlName);
  //       if (childIndex >= 0) {
  //         childrens = uniqueset[childIndex].children.filter(elem => elem.valueControl === true)
  //       }
  //       displayarr.unshift({
  //         tierValue: ele.controlName,
  //         tierDescription: this.checkTitle(ele),
  //         tierchildren: childrens,
  //         checkAllChildValue: this.checkAllChildValue(childrens),
  //         edditedControlName: lebel
  //       });
  //       parent = ele.parent;
  //     }
  //   });
  //   var ParentChildJson = { formJsonTree: fullTree, selectedDataTree: displayarr }
  //   return ParentChildJson;
  // }
  // checkAllChildValue(tierchildren) {
  //   var allChildHasValue = tierchildren.filter(el => (el.value != undefined && el.value != ''));
  //   return allChildHasValue.length == tierchildren.length;
  // }
  getSelectedChildObject(control, parent, child) {
    const indexOfSelectZone = this.indexOfSelectZone
    var indexOfSelectedCat = this.serverData[this.indexOfSelectZone].templateJson.findIndex(e => e.controlName == child && e.parent == parent && e.name == control);
    return { ZoneIndex: indexOfSelectZone, indexOfSelectedCat: indexOfSelectedCat };
  }
  getSelectedZoneIndex(Zone: string) {
    let indexOfSelectZone = this.indexOfSelectZone;
    // indexOfSelectZone = this.serverDataKeys.findIndex(elemn => elemn == Zone);
    return indexOfSelectZone;
    //return 0;
  }
  isValidJson(jsonstring) {
    return ((x) => { try { JSON.parse(x); return true; } catch (e) { return false } })(jsonstring)
  }
  getParentControlTitle(zoneIndex, controlName) {
    var controls = this.serverData[zoneIndex].templateJson.filter(cat => cat.controlName == controlName && cat.controlType == "title");
    var ParentControlTitle = ""
    if (controls.length > 0) {
      var ele = controls[0];
      ParentControlTitle = (ele.hasOwnProperty('props')) ? (ele.props['text'] ? ele.props['text'] : ele.controlName) : ele.controlName;
    }
    return ParentControlTitle;
  }
  // getValidationList(element, tempelement) {
  //   if (element.children.length > 0) {
  //     element.children.map(res => {
  //       if ((res.recommended == undefined || !res.recommended) && res.mandatory == 0 && (res.value == undefined || res.value == "")) {
  //         if (res.children.length > 0) {
  //           this.getValidationList(res, tempelement)
  //           var checkval = res.children.filter(item => (item.value != undefined && item.value != ""))
  //           if (checkval.length > 0) {
  //             res.mandatory = 1;
  //             res.value = "Filled";
  //             if (res.ImpactOnGroup == "Yes") {
  //               element.children.map(item => {
  //                 if (item.mandatory == 0 && item.children.length > 0 && item.ImpactOnGroup == "Yes") {
  //                   item.mandatory = 1;
  //                   item.value = "To be Filled";
  //                 }
  //               })
  //             }
  //             this.getValidationList(tempelement, tempelement);
  //           }
  //           else {
  //           }
  //         }
  //         else {
  //         }
  //       }
  //       else if ((res.recommended == undefined || !res.recommended) && res.mandatory == 1 && res.children.length > 0) {
  //         var checkval = res.children.filter(item => ((item.recommended == undefined || !item.recommended) && item.mandatory == 1 && (item.value == undefined || item.value == "")))
  //         if (checkval.length > 0) {
  //           res.recommended = true;
  //           res.children.map(result => result.recommended = true);
  //           checkval.forEach(resultant => {
  //             if (resultant.hasOwnProperty('noImageReason')) {
  //               resultant.noImageReason = this.isValidJson(resultant.noImageReason) ? JSON.parse(resultant.noImageReason) : [];
  //             }
  //             this.serverDataValidation.push(resultant);
  //           });
  //         }
  //         else {
  //         }
  //       }
  //       else if ((res.recommended == undefined || !res.recommended) && res.mandatory == 1 && (res.value == undefined || res.value == "")) {
  //         var checkval = element.children.filter(item => (item.ImpactOnGroup == "Yes" && item.value != undefined && item.value != ""))
  //         if (res.ImpactOnGroup == "Yes" && checkval.length > 0) {
  //           res.recommended = true;
  //           if (res.hasOwnProperty('noImageReason')) {
  //             res.noImageReason = this.isValidJson(res.noImageReason) ? JSON.parse(res.noImageReason) : [];
  //           }
  //           this.serverDataValidation.push(res);
  //         }
  //         else {
  //         }
  //       }
  //       else if ((res.recommended == undefined || !res.recommended) && res.mandatory == 2 && (res.value == undefined || res.value == "")) {
  //         res.recommended = true;
  //       }
  //       else {
  //         if (res.ImpactOnGroup == "Yes") {
  //           element.children.map(item => {

  //             if (item.mandatory == 0 && item.children.length > 0 && item.ImpactOnGroup == "Yes") {
  //               item.mandatory = 1;
  //               item.value = "To be Filled";
  //             }
  //           })
  //         }
  //       }
  //     });
  //   }
  // }
  // getClassValue(element, tempelement, zoneName) {
  //   if (element.children.length > 0) {
  //     element.children.map(res => {
  //       if (res.mandatory == 0 && (res.value == undefined || res.value == "")) {
  //         if (res.children.length > 0) {
  //           this.getClassValue(res, tempelement, zoneName);
  //           var checkval = res.children.filter(item => (item.value != undefined && item.value != ""))
  //           if (checkval.length > 0) {
  //             res.mandatory = 1;
  //             res.value = "Filled";
  //             var count = res.children.length - checkval.length;
  //             // var classCalc = count / res.children.length; 
  //             this.addClass(res, zoneName, count, res.children.length);
  //             this.getClassValue(tempelement, tempelement, zoneName);
  //           }
  //           else {
  //             this.removeClass(res, zoneName);
  //           }
  //         }
  //         else {
  //           this.removeClass(res, zoneName);
  //         }
  //       }
  //       else if (res.mandatory == 1 && res.children.length > 0) {
  //         var checkval = res.children.filter(item => (item.value != undefined && item.value != ""))
  //         if (checkval.length > 0) {
  //           checkval.forEach(resultant => {
  //             this.addClass(resultant, zoneName, 0, 0);
  //           });
  //         }
  //         else {
  //           res.children.forEach(resp => {
  //             this.removeClass(resp, zoneName);
  //           });
  //         }
  //       }
  //       else if (res.mandatory == 1 && (res.value == undefined || res.value == "")) {
  //         this.removeClass(res, zoneName);
  //       }
  //       else if (res.mandatory == 2 && (res.value == undefined || res.value == "")) {
  //         this.removeClass(res, zoneName);
  //       }
  //       else {
  //         if (res.value != undefined || res.value != "") {
  //           this.addClass(res, zoneName, 0, 0);
  //         }
  //       }
  //     });
  //   }
  // }
  // addClass(res, zoneName, count, classCalc) {
  //   var tempCalc = 90 + (360 * (1 - (count / classCalc)));
  //   this.serverData[zoneName][0].data.forEach(e => {
  //     if (res.name == e.name) {
  //       this.removeClass(res, zoneName);
  //       if (count > 0) {
  //         e.ui.description = e.ui.description.split("]").length > 1 ? e.ui.description.split("]")[1].trim() : e.ui.description.split("]")[0].trim();
  //         e.ui.description = '[' + count + "*] " + e.ui.description;
  //         var checkele = document.getElementsByName(e.name);
  //         if (checkele.length > 0) {
  //           document.getElementsByName(e.name)[0].classList.add("btn-circlepartialcompleted" + tempCalc)
  //         }
  //         e.ui.class.push('btn-circlepartialcompleted' + tempCalc);
  //       }
  //       else {
  //         e.ui.description = e.ui.description.split("]").length > 1 ? e.ui.description.split("]")[1].trim() : e.ui.description.split("]")[0].trim();
  //         var checkele = document.getElementsByName(e.name);
  //         if (checkele.length > 0) {
  //           document.getElementsByName(e.name)[0].classList.add("btn-circlecompleted");
  //         }
  //         e.ui.class.push('btn-circlecompleted');
  //       }
  //       e.ui.class = [...new Set(e.ui.class)]
  //     }
  //   });
  // }
  // removeClass(res, zoneName) {
  //   this.serverData[zoneName][0].data.forEach(ele => {
  //     if (res.name == ele.name) {
  //       ele.ui.description = ele.ui.description.split("]").length > 1 ? ele.ui.description.split("]")[1].trim() : ele.ui.description.split("]")[0].trim();
  //       let collectedTerm = 'btn-circlecompleted';
  //       let c = ele.ui.class.filter(item => item.toLowerCase().indexOf(collectedTerm) > -1);
  //       if (c.length > 0) {
  //         c.forEach(el => {
  //           var checkele = document.getElementsByName(el);
  //           if (checkele.length > 0) {
  //             document.getElementsByName(ele.name)[0].classList.remove(el);
  //           }
  //           var valuepartialIndex = ele.ui.class.indexOf(el);
  //           if (valuepartialIndex != -1) {
  //             ele.ui.class.splice(valuepartialIndex, 1);
  //           }
  //         });
  //       }
  //       let term = 'btn-circlepartialcompleted';
  //       let b = ele.ui.class.filter(item => item.toLowerCase().indexOf(term) > -1);
  //       if (b.length > 0) {
  //         b.forEach(element => {
  //           var checkele = document.getElementsByName(element);
  //           if (checkele.length > 0) {
  //             document.getElementsByName(ele.name)[0].classList.remove(element);
  //           }
  //           var valuepartialIndex = ele.ui.class.indexOf(element);
  //           if (valuepartialIndex != -1) {
  //             ele.ui.class.splice(valuepartialIndex, 1);
  //           }
  //         });
  //       }
  //       ele.ui.class = [...new Set(ele.ui.class)];
  //     }
  //   });
  // }
  // updateNoImagesArray() {
  //   if (this.noCatImageReason && this.noCatImageReason.length > 0) {
  //     this.noCatImageReason.forEach((result) => {
  //       var selectedZone = this.getSelectedChildObject(result.name, result.parent, result.controlName);
  //       if (this.serverData[this.indexOfSelectZone].templateJson[selectedZone.indexOfSelectedCat].hasOwnProperty("value")) {
  //         var allCatValues = this.serverData[this.indexOfSelectZone].templateJson[selectedZone.indexOfSelectedCat].value;
  //         if (allCatValues.length > 0) {
  //           this.noCatImageReason = this.noCatImageReason.filter(ele => ele.name != result.name)
  //         }
  //       }
  //     });
  //   }
  // }



  // highlightMandatoryControls() {
  //   // try {
  //   //   this.serverData = this.serverData.map(task => ({
  //   //     ...task,
  //   //     templateJson: task.templateJson.map(control => {
  //   //       const shouldHighlight =
  //   //         control.mandatory === 1 &&
  //   //         (!Array.isArray(control.value) || control.value.length === 0);
  //   //       return {
  //   //         ...control,
  //   //         ...(shouldHighlight && { highlightControl: true })
  //   //       };
  //   //     })
  //   //   }));
  //   //   console.log("updatedData", this.serverData);
  //   // } catch (error) {
  //   //   console.error('Error while updating highlightControl:', error);
  //   // }
  //   try {
  //     this.serverData.forEach(task => {
  //       const controls = task.templateJson;

  //       // Create map for quick parent lookup
  //       const controlMap = new Map<string, any>();
  //       controls.forEach(control => {
  //         if (control.controlName) {
  //           controlMap.set(control.controlName, control);
  //         }
  //       });

  //       controls.forEach(control => {
  //         const shouldHighlight =
  //           control.mandatory === 1 &&
  //           (!Array.isArray(control.value) || control.value.length === 0);

  //         if (shouldHighlight) {
  //           // Highlight current control
  //           control.highlightControl = true;

  //           // If it has parent → highlight parent also
  //           if (control.parent) {
  //             const parentControl = controlMap.get(control.parent);
  //             if (parentControl) {
  //               parentControl.highlightControl = true;
  //             }
  //           }
  //         } else {
  //           delete control.highlightControl;
  //         }
  //       });
  //     });
  //     console.log("updatedData", this.serverData);
  //   } catch (error) {
  //     console.error('Error while updating highlightControl:', error);
  //   }

  // }
}
function providedIn(providedIn: any, arg1: string) {
  throw new Error('Function not implemented.');
}